// import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } 	from 'gsap/ScrollSmoother';

//import { tsParticles } from "@tsparticles/engine";
//import { Draggable } from 'gsap/Draggable';
//import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, ScrollSmoother);
ScrollTrigger.config({ ignoreMobileResize: true});

import { debounce as _debounce, random as _random } from 'underscore';
//import '@benmajor/jquery-touch-events';


//let console = window.console;

export default class EFFEX{

    constructor(options) {

        this.defaults = {
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

        this.namespace = 'effx';
		this.$window = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $('body');
		this.overshoot = 100;

		this.main = this.options.main;

		this.ids = [];

    }

	init(){

		this.addEvents( true );

		//this.hideHeaderWhenHomePageFooter( );

		//setTimeout( ()=>this.initScrollColsAtDifferentSpeed(), 17 );


		/*
		this.setNavigationState();
		this.lockTimelineSidebar();
		this.lockShareButtons();
		setTimeout( ()=>this.lockSubmenuSectionsAbout(), 277 );
		*/

		//this.initGAScrollEvent();
		//this.initParallax();

		

		
		//------------------- desktop ---------------------//
		this.initDesktopNavScrollHide();
		this.lockSidebar();
		this.lockShare();
		//this.setBurgerPin();
		


		//------------------- mobile ---------------------//
		this.initNavMobileFixed();
		//this.initNavMobileCompact();
		//this.initNavMobileCompactFixed();
		
		/*
		setTimeout( ()=>this.setBurgerMobilePin(), 0);
		

		this.setMenuSubPagesMobilePin();
		this.initMobileSubmenuPages();
		this.initSubmenuPages();

		this.initSubmenuSticky();
		

		this.initModuleHortFiltersSticky();
		*/

		//this.checkView();

		this.initMenuScroll();

		//this.initFireworks();

	}

	reset(){
		this.destroy();
		this.init()
	}

	//------------------------------------------ UTILS -----------------------------------------//
	addEvents( b ){
		if ( b ){
			this.r = _debounce( ()=>{ this.onResize() }, 200 );
			this.$window.on( 'resize', this.r );
		}
		else{
			if ( this.r ){
				this.r.cancel();
				this.$window.off( 'resize', this.r );
			}
		}
	}

	onResize(){		
		//this.lockTimelineSidebar();
		//

		this.lockShare();
		this.lockSidebar();

		// this.lockSubmenuSectionsAbout();
		// this.initScrollColsAtDifferentSpeed();
	}

	getWindowHeight(){
		return this.$window.height();
	}
	getDocHeight(){
		return this.$doc.height();
	}

	//------------------------------------------ GA SCROLL EVENT ---------------------------------//
	initGAScrollEvent(){
		ScrollTrigger.create({
			trigger: $('main'),
			start: "center center",
			end: "center center",
			scroller: $(this.main.options.$scroll_el),
			//scrub: true,
			//markers: true,
			id: this.getID(),
			onEnter: self =>{
				//console.log( 'enter' )
				//this.$body.addClass( 'activate-nav-compact' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			},
			onEnterBack: self =>{
				//console.log( 'enter back' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			}
		}) 		
	}


	
	//------------------------------------------ EFFECTS -----------------------------------------//


	initDesktopNavScrollHide(){

		//return;

		let $el = $('#desktop-header'), $trigger, start;

		if ( $el.length > 0 ){

			$trigger = $( '.trigger-nav-hide' );
			
			// change the trigger to first slide if found (like homepage) : Header start to hide after passed the first slide ( trigger-nav-hide)	
			if ( $trigger.length > 0 ){
				start = "bottom top"; //+=100px";
			}
			else{

				// otherwise make it work always

				$trigger = $el;
				start = "top top";

				//if ()
			}
		
			ScrollTrigger.create({

				trigger: $trigger,
				start: start,
				
				end: ()=>{ return this.getDocHeight() }, //- this.getWindowHeight()  },
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false,
				id: this.getID(),
				pin: true,
				pinSpacing: false,
				toggleClass: 'pinned',

				onEnter: ()=>{
					//console.log( 'enter' )
					//this.$body.addClass( 'activate-nav-compact' )
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
				},
				onLeave: ()=>{
					//this.$body.removeClass( 'activate-nav-compact' )
					//console.log( 'leave' )
				},
				onUpdate: self => {				
					let y = self.scroll(), yback = 300, /*$trigger.height(), */ direction = self.direction, $a = $('#announcement-bar'), progress = self.progress;



					if ( $('.module-escr-hero').hasClass( 'has-submenu' ) ){
						//return;
					}



					if ( progress >= 0.97 ){
						this.$body.removeClass( 'hide-desktop-nav' ).removeClass( 'scroll-direction-back' );
						return;
					}


					if ( $a.length > 0 ){
						yback += $a.height();
					}

					// activate nav compact				
					if ( direction === 1 ){
						if ( y >= yback ){
							this.$body.addClass( 'hide-desktop-nav' )
						}
					}
					else if ( direction === -1 ){
						if ( y < yback + 30 ){
							this.$body.removeClass( 'hide-desktop-nav' ).removeClass( 'scroll-direction-back' );
						}
					}
					
					// track direction of scrolling
					if ( this.$body.hasClass( 'hide-desktop-nav' ) ){
						if ( direction === 1){
							this.$body.removeClass( 'scroll-direction-back' );
						}
						else{
							this.$body.addClass( 'scroll-direction-back' );
						}					
					}
				}
			});


			// secondary nav
			$trigger = $('nav.submenu-pages');
			if ( $trigger.length > 0 ){

				//start = "top top+=59px";
				start = "top top-=1px";

				ScrollTrigger.create({

					trigger: $trigger,
					start: start,
					
					end: ()=>{ return this.getDocHeight() }, //- this.getWindowHeight()  },
					//toggleClass: "activate-nav-compact",
					scrub: true,
					markers: false,
					id: this.getID(),
					pin: true,
					pinSpacing: false,
					toggleClass: 'pinned',
				});
			}

		}
	}

	initNavMobileFixed(){

		
		let $el = $('#mobile-header'), $trigger, start;

		if ( $el.length > 0 ){


			$trigger = $( '.trigger-nav-hide' );
			
			// change the trigger to first slide if found (like homepage) : Header start to hide after passed the first slide ( trigger-nav-hide)	
			if ( $trigger.length > 0 ){
				start = "bottom top+=80px";
			}
			else{

				// otherwise make it work always

				$trigger = $el;
				start = "top top";
			}

			ScrollTrigger.create({
				trigger: $trigger,
				start: start, //"top+=20px top",
				end: ()=>{ 
					return this.getDocHeight(); // - this.getWindowHeight() 
				},
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false, //true,
				pin: true,
				pinSpacing: false,
				id: this.getID(),

				onEnter: ()=>{
					//console.log( 'enter' )
					//this.$body.addClass( 'activate-nav-compact' )
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
				},
				onLeave: ()=>{
					//this.$body.removeClass( 'activate-nav-compact' )
					//console.log( 'leave' )
				},

				/*
				onUpdate: self => {				
					let y = self.scroll(), yback = $el.height(), direction = self.direction;

					if ( this.$body.hasClass( 'home' ) ) {
						if ( self.progress > 0.93 ){
							this.$body.addClass( 'hide-mobile-nav' );
							return;
						}
						else{
							this.$body.removeClass( 'hide-mobile-nav' );
						}
					}

					// activate nav compact				
					if ( direction === 1 ){
						if ( y >= yback ){
							this.$body.addClass( 'activate-nav-compact' )
						}
					}
					else if ( direction === -1 ){
						if ( y < yback + 30 ){
							this.$body.removeClass( 'activate-nav-compact' ).removeClass( 'scroll-direction-back-mobile' );
						}
					}
					// track direction of scrolling
					if ( this.$body.hasClass( 'activate-nav-compact' ) ){
						if ( direction === 1){
							this.$body.removeClass( 'scroll-direction-back-mobile' );
						}
						else{
							this.$body.addClass( 'scroll-direction-back-mobile' );
						}					
					}
				}
				*/
			})
		}
	}



	/*
	hideHeaderWhenHomePageFooter(){
		if ( this.$body.hasClass( 'home' ) ){
			let $el = $('main');
				if ( $el.length > 0 ){

					ScrollTrigger.create({
						trigger: $el,
						start: "bottom top+=100px",
						end: "bottom top+=100px",
						scrub: true,
						markers: false,
						id: this.getID(),

						onEnter: ()=>{
							//console.log( 'enter' )
							this.$body.addClass( 'hide-desktop-nav' )
						},
						onEnterBack: ()=>{
							//console.log( 'enter back' )
							this.$body.removeClass( 'hide-desktop-nav' )
						}
					})

				}

		}
	}
	*/


     /*
	initNavMobileCompact(){
		let $el = $('#mobile-header');

		if ( $el.length > 0 ){

			ScrollTrigger.create({
				trigger: $el,
				start: "top+=20px top",
				end: ()=>{ 
					return this.getDocHeight() - this.getWindowHeight() 
				},
				//toggleClass: "activate-nav-compact",
				scrub: false,
				markers: false,
				pin: true,
				pinSpacing: false,
				id: this.getID(),

				onEnter: ()=>{
					//console.log( 'enter' )
					//this.$body.addClass( 'activate-nav-compact' )
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
				},
				onLeave: ()=>{
					//this.$body.removeClass( 'activate-nav-compact' )
					//console.log( 'leave' )
				},
				onUpdate: self => {				
					let y = self.scroll(), yback = $el.height(), direction = self.direction;

					if ( this.$body.hasClass( 'home' ) ) {
						if ( self.progress > 0.93 ){
							this.$body.addClass( 'hide-mobile-nav' );
							return;
						}
						else{
							this.$body.removeClass( 'hide-mobile-nav' );
						}
					}

					// activate nav compact				
					if ( direction === 1 ){
						if ( y >= yback ){
							this.$body.addClass( 'activate-nav-compact' )
						}
					}
					else if ( direction === -1 ){
						if ( y < yback + 30 ){
							this.$body.removeClass( 'activate-nav-compact' ).removeClass( 'scroll-direction-back-mobile' );
						}
					}
					// track direction of scrolling
					if ( this.$body.hasClass( 'activate-nav-compact' ) ){
						if ( direction === 1){
							this.$body.removeClass( 'scroll-direction-back-mobile' );
						}
						else{
							this.$body.addClass( 'scroll-direction-back-mobile' );
						}					
					}
				}
			})
		}
	}
	*/

	/*
	setNavigationState(){

		let $el, topTrigger, $p, id = this.getID();
		if ( this.$body.hasClass( 'home' ) || this.$body.hasClass( 'page-template-ideas' ) || this.$body.hasClass( 'single-ideas' ) || this.$body.hasClass( 'tax-ideas_category' ) ){

			this.$body.addClass( 'navigation-white-state' );

			$el = $('.trigger-navigation-off-white-state');
			if ( $el.length > 0 ){

				topTrigger = 'top';
				$p = $el.prev();
				topTrigger += '-=' + $p.css( 'margin-bottom' );

				//console.log( $p.css( 'margin-bottom' ) );

				ScrollTrigger.create({
					trigger: $el,
					start: topTrigger + " top+=77px",
					end: topTrigger + " top+=77px",
					scrub: false,
					markers: false,
					id: id,

					onEnter: ()=>{
						//console.log( 'enter' )
						this.$body.removeClass( 'navigation-white-state' )
					},
					onEnterBack: ()=>{
						//console.log( 'enter back' )
						this.$body.addClass( 'navigation-white-state' )
					}
				})

			}
		}
	}
	*/

	/*
	lockTimelineSidebar(){
		let $el = $('aside .timeline-content'), end, $p, id;
		if ( $el.length > 0 ){

			if ( $el.attr('id') ){
				this.killById( $el.attr('id') );
			}

			if ( this.$window.width() > 767 ){

				if ( this.$window.height() < $el.height() ){
					return;
				}

				id = this.getID();
				$el.attr( 'id', id );

				end = $( '.sidebar-right' ).height() - ($el.offset().top - $( '.sidebar-right' ).offset().top) - $el.height() ;
				$p = $( '.module-sidebar-related-projects' );
				if ( $p.length > 0 ){
					end -= $p.height() + 100;
				}

				ScrollTrigger.create({
					trigger: $el,
					pin: true,
					pinSpacing: false,
					start: 'top+=' + $el.height()/2 + 'px center',
					end: '+=' + end,
					scrub: false,
					//markers: true,
					id: id
				})

			}

		}
	}
	*/

	
	lockSidebar(){
		let $el = $('#sidebar-info'), end, id, 
		htop = $('#desktop-header').height() + 20;
		if ( $el.length > 0 ){

			if ( $el.attr('id') ){
				this.killById( $el.attr('id') );
			}

			if ( this.$window.width() > 1023 ){

				if ( this.$window.height() < ($el.height()+htop) ){
					return;
				}

				id = this.getID();
				$el.attr( 'id', id );

				end = $( '.sidebar' ).height() - $el.offset().top - 40;

				ScrollTrigger.create({
					trigger: $el,
					pin: true,
					pinSpacing: false,
					start: 'top-=' + htop  + 'px top',
					endTrigger: $('.footer.smooth'),
					end: 'top bottom',
					scrub: true,
					//markers: true,
					id: id
				})

			}
		}
	}
	
	lockShare(){
		let $el = $('.module-share-container'), end, id, $gridmodule, 
		htop = $('#desktop-header').height() + 20, args;
		if ( $el.length > 0 ){

			$el.each( (i,el)=>{


				$el = $(el);

				if ( $el.attr('id') ){
					this.killById( $el.attr('id') );
				}

				if ( $el.css('position') === 'absolute' ){

					if ( this.$window.height() < ($el.height()+htop) ){
						return;
					}

					id = this.getID();
					$el.attr( 'id', id );

					args = {
						trigger: $el,
						pin: true,
						pinSpacing: false,
						start: 'top-=' + htop  + 'px top',
						endTrigger: $('.footer.smooth'),
						end: 'top-=60px bottom',
						scrub: true,
						//markers: false,
						id: id					
					};

					
					/*
					$gridmodule = $( '.article-modules-container' ).find( '.module-grid' ); 
					if ( $gridmodule.length > 0 ){
						//console.log( $gridmodule[0] );

						end = $el.offset().top + $el.outerHeight();
						args['endTrigger'] = $($gridmodule[0]);
						args['end'] = '+=' + end;

					}
					else{
						end = $( '.sidebar' ).height() - $el.offset().top - 40;
						args['end'] = '+=' + end;
					}
					*/


					ScrollTrigger.create( args );

					/*
					ScrollTrigger.create({
						trigger: $el,
						pin: true,
						pinSpacing: false,
						start: 'top-=' + htop  + 'px top',
						//endTrigger: $('.footer'),
						end: '+=' + end,
						scrub: true,
						markers: false,
						id: id
					})
					*/

				}

			});
		}
	}


	initMenuScroll(){
		let $el = $('.menu-scroll'), $a, $target;
		if ( $el.length > 0 ){
			$el.find( 'a').on( 'click', (e)=>{

				e.preventDefault();

				$a = $(e.currentTarget);
				$target = $('#' + $a.attr('href'));
				if ( $target.length > 0 ){
					if ( this.main.smoother ){
						this.main.smoother.scrollTo( $target, true, "top 120px");
					}
					else{
						gsap.to( $(window), {duration: 0.4, scrollTo: { y : $target[0], offsetY: 120 }, ease: 'power.easeOut' });
					}
				}
			});
		}
	}

	/*
	lockSubmenuSectionsAbout(){

		//return;

		let $el = $( '#nav-sections' ), start, id, $a, $section, offset;
		if ( $el.length > 0 ){

			if ( $el.data('id') ){
				this.killById( $el.data('id') );

				for( let i=0; i< $el.find( '.menu.sections a' ).length; i++ ){
					this.killById( $el.data('id') + '-' + i );
				}

			}
			id = this.getID();
			$el.data( 'id', id );

			start = this.$window.width() < 768 ? $('#mobile-header').height() : $('#desktop-header .header-bg').height();

			ScrollTrigger.create({
				trigger: $el,
				start: "top top+=" + start + 'px', // below header
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() + this.overshoot },
				toggleClass: "pinned",
				scrub: true,
				markers: false,
				id: id
			});




			// this is an offset invisible after on the elements trigger, used to give necessary offset to ccompensate the fixed header
			offset = this.$window.width() < 768 ? 150 : 180;

			// check when the section scroll to a certain level !!!!
			$el.find( '.menu.sections a' ).each( (i,el)=>{
				$a = $(el);

				if ( i=== 0 ){
					$section  = $( $a.attr( 'href' ) );
					// set the first item seleted
					this.setSelectionMenu( {trigger: $section[0]}, $el.find('.sections') );
				}

				ScrollTrigger.create({
					trigger: $( $a.attr( 'href' ) ),
					start: "top center-=" + offset,
					end: "+=" + $( $a.attr( 'href' ) ).height(),
					markers: false,
					id: id + '-' + i,
					onEnter: self=>{
						//let $s = $el.find('.sections a[href="#' + $( self.trigger ).attr('id') + '"]');
						//$s.parent().addClass( 'active' );
						this.setSelectionMenu( self, $el.find('.sections') );
					},
					onEnterBack: self=>{
						this.setSelectionMenu( self, $el.find('.sections') );
					},
				});
			});
		}
	}
	*/

	/*
	setSelectionMenu( self, $menu ){
		let hash = $( self.trigger ).attr('id'), 
			$a = $menu.find('a[href="#' + hash + '"]');

		// clear selection
		$menu.find( 'li' ).removeClass( 'active' );
		// set  selection
		$a.parent( 'li' ).addClass( 'active' );
		//  change url hash
		// this.changeHashUrl( hash );
	}
	*/

	changeHashUrl( hash ){
		history.replaceState(null, null, document.location.pathname + '#' + hash );
	}


	/*
	setBurgerPin(){
		let $el = $('#burger');

		ScrollTrigger.create({
			trigger: $el,
			start: "top top+=10",
			pin: true,
			pinSpacing: false,
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID()
		})
	}
	*/

	/*
	setMobileHeaderPin(){
		let $el = $('#mobile-header');
		if ( $el.length > 0  && !this.$body.hasClass( 'home' )  ){

			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false,
				id: this.getID()
			})

		}
	}
	*/
	

	/*
	setBurgerMobilePin(){
		let $el = $('#burger-mobile');
		ScrollTrigger.create({
			trigger: $el,
			start: "top top+=5",
			pin: true,
			pinSpacing: false,
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID()
		})
	}
	*/

	/*
	setMenuSubPagesMobilePin(){
		let $el = $('#submenu-pages-mobile');
		if ( $el.length > 0  ){

			ScrollTrigger.create({
				trigger: $el,
				start: "top top+=60", // below header
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false,
				id: this.getID()
			})
		}
	}
	*/

	/*
	initMobileSubmenuPages(){
		let $el = $('.submenu-pages-mobile .scroll-layer'), $c, tox;

		if ( $el.length > 0 ){

			if ( this.draggableSubmenuPages ){
				// this.draggableSubmenuPages.kill();
			}

			//  set correct width of the scroller to the menu length (+ margin to scroll below the shadow)
			$el.width( Math.ceil( $el.find( 'ul' ).width() + 70 ) );

			// set draggable
			this.draggableSubmenuPages = Draggable.create( $el, {
			    type:"x",
			    bounds: $el.parent(),
			    // THIS NEED INIERTIA PLUGIN!!!!!!!!!
			    inertia: true     
			});

			// set current selection
			setTimeout( () => {
				$c = $el.find( 'li.current-menu-item' );
				if ( $c.length > 0 ){
					tox = Math.min( $c.offset().left - 20 , $el.width() - this.$window.width() );
					//console.log( tox );
					gsap.set( $el, { x: - tox } );
				}
			}, 200 );
		}
	}
	*/

	/*
	initSubmenuPages(){
		let $el = $('.submenu-pages-desktop' ), sw, w, n, ww = this.$window.width(), d= false, $d;
		if ( $el.length > 0 ){
			sw = $el.find( '.menu.horizontal.nav-text' ).width();
			w = $el.parent().width();
			n = $el.parent().find( '.name' ).width();

			// make it not wrapping below the title
			if ( sw < w - n - 20 ){
				$el.css({
					width: 'auto'
				})
			}
			else{
				$el.width( w - n - 20 );
				d = true;
			}

			// adjust padding for small screens
			$el.css({
				'padding-top': ww<=870?3:7
			});

			// set draggable
			$d = $el.find( '.menu' );
			if ( Draggable.get($d) ){
				Draggable.get($d).kill()
			}


			if ( d ){
				$d.css({'padding-right': 70 });
				$el.find( '.shadow' ).css({opacity:1});
				Draggable.create( $d, {
				    type:"x",
				    bounds: $el,
				    // THIS NEED INIERTIA PLUGIN!!!!!!!!!
				    inertia: true     
				});

				// set current selection
				setTimeout( () => {
					let $c = $d.find( 'li.current-menu-item' ), tox;
					if ( $c.length > 0 ){
						tox = Math.min( $c.position().left , $d.width() - $el.width() );
						//console.log( tox );
						gsap.set( $d, { x: - tox } );
					}
				}, 0 );

			}
			else{
				$d.css({'padding-right': 0 });
				$el.find( '.shadow' ).css({opacity:0});
			}
		}
	}
	*/

	/*
	initModuleHortFiltersSticky(){
		let $el = $('.module-hort-filters');

		if ( $el.length > 0  ){
			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: $el,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() + 100 - this.getWindowHeight() },
				scrub: true,
				markers: false,
				id: this.getID(),
				toggleClass: 'is-sticky',
				onToggle: self =>{
					if( self.direction === 1 ){
						$( 'body' ).addClass( 'is-anchor-menu-sticky' );
					}
					else{
						$( 'body' ).removeClass( 'is-anchor-menu-sticky' );
					}
				}			
			})
		}		
	}
	*/

	/*
	initSubmenuSticky(){
		let $el = $('.submenu-pages nav.sticky');

		if ( $el.length > 0  ){

			this.$body.addClass( 'has-submenu-sticky' )

			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: $el,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				scrub: true,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if ( self.isActive ){
						this.$body.addClass( 'is-submenu-sticky' )
					}
					else{
						this.$body.removeClass( 'is-submenu-sticky' )
					}
				}
			})
		}
	}
	*/

	/*
	initFireworks(){
		if ( this.$body.hasClass( 'home' ) ){
			
			console.log( 'initFireworks' );


			tsParticles.load({
			    id: 'escr-hero',
			    options: {
			    },
			    preset: "fireworks"
			}).then(container => {
        		console.log("callback - tsparticles config loaded");

        		

		    }).catch(error => {
		        console.error(error);
		    });

			const particles = tsParticles.domItem(0);

			// play will start the animations, if the move is not enabled it won't enable it, it just updates the frame
			particles.play();

		}
	}
	*/

	//-------------------------------------- UTILS -------------------------------//
	initParallax(){
		let $el = $('.parallax');
		
		if ( this.$window.width() < 768 ){
			return;
		}

		if ( $el.length > 0 ){
			$el.each( (i, el)=>{
				let y = _random( -3, 5 )*5;
				$(el).attr( 'data-parallax-yp', y );
				gsap.to( $(el), {
					yPercent: y,
					ease: "none",
					scrollTrigger: {
						trigger: $(el),
						// start: "top bottom", // the default values
						// end: "bottom top",
						scroller: $(this.main.options.$scroll_el),
						scrub: true,
						markers: false,
						id: this.getID(),
						toggleClass: 'in-parallax'
					} 
				})
			})
		}
	}	


	staggerItemGrid( $el ){
		let $item, delay_init, delay, j, first, stagger, 

		maxDelay = 0.9;

		if ( $el.length > 0 ){

			first = true;
			j = 0;
			stagger = 0.1;

			$el.each( (i, el)=>{

				$item = $(el);

				if ( i === 0 ){
					// get the start delay from CSS
					delay = delay_init = parseFloat($item.css( 'transition-delay' ));
				}

				// stagger effect grid
				if ( $item.hasClass( 'effect-grid' ) ){

					// stagger delay for item in vieport
					if ( ScrollTrigger.isInViewport( $item[0] ) ){

						// this items for artists lists need a little more stagger
						if ( $item.hasClass( 'item-artist' ) ){
							//stagger = 0.7;
						}

						delay += stagger*j*0.5;

					}
					else{

						// the other still not visible reduce the stagger
						if ( first ){

							// reset delay for first item not visible in viewport
							first = false;
							j = 0;
							delay = delay_init;
							stagger = 0.07;

							// this item are a list, so we don't need any stagger (only for grid)
							if ( $item.hasClass( 'item-artist' ) ){
								//stagger = 0;
							}

						}
						
						delay += stagger*j*0.27;

						// when we reach a max, we start again from 0 to avoid excessive delay fro items not visible in vieport
						if ( delay > maxDelay ){
							delay = delay_init;
						}

					}
					
					$item.css({
						'transition-delay' : delay + 's'
					})

					j++;
				}

			})
		}
	}

	checkView(){
		let $el = $('.check-view'), $item;
		if ( $el.length > 0 ){

			if ( this.$window.width() >= 768 ){
				this.staggerItemGrid( $el );
			}

			$el.each( (i, el)=>{

				$item = $(el);

				if ( ScrollTrigger.isInViewport( $item[0] ) ){
					$item.addClass( 'in-view'  );
				}
				else{
					// we don't need the id to reference the ScrollTrigger, because once=true. So after play once it goes in Garbage collection automatically.
					ScrollTrigger.create({
						trigger: $item,
						// start: "top bottom", // the default values
						// end: "bottom top",
						//scroller: $(this.main.options.$scroll_el),
						scrub: false,
						markers: false,
						
						toggleClass: 'in-view',
						once: true,

						/*
						id: this.getID(),
						onToggle: self => {
							$el = $(self.trigger);
							if ( !$el.hasClass( 'in-view' ) ){
								$el.addClass( 'in-view' );
							}
						}
						*/
					});
				}
			})
		}
	}	

	//-------------------------------------------- UTILS ------------------------------//
	clearScrolls( arr ){
		let i = arr.length, $el, id;
		while( i-- ){
			$el = arr[ i ];
			id = $el.attr( 'scroll_id' );
			if ( id ){
				this.killById( id );
				gsap.killTweensOf( $el );
				gsap.set( $el, {clearProps: 'all' });
				$el.attr( 'scroll_id', false );
			}
		}
	}

	assignID( $el ){
		const id = this.getID();
		$el.attr( 'scroll_id', id );
		return id;
	}

	getID(){
		const id = 'id_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroy(){
      	this.addEvents( false );
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}
			
}



